/* eslint-disable react/prop-types */
import React from 'react';
import { IconInfo, PageLevelMessage } from '@americanexpress/dls-react';
import PropTypes from 'prop-types';

export const DisplayWarningMessage = ({
  messageDataList,
  dismissible = false,
}) => (
  <PageLevelMessage type="warning" dismissible={dismissible}>
    {messageDataList?.length === 1
      ? messageDataList[0]
      : (
        <ul>
          {messageDataList.map((msg) => (
            <li key={msg}>{msg}</li>
          ))}
        </ul>
      )}
  </PageLevelMessage>
);

export const DisplaySuccessMessage = ({
  messageDataList,
  dismissible = false,
}) => (
  <PageLevelMessage type="success" dismissible={dismissible}>
    {messageDataList?.length === 1
      ? messageDataList[0]
      : (
        <ul>
          {messageDataList.map((msg) => (
            <li key={msg}>{msg}</li>
          ))}
        </ul>
      )}
  </PageLevelMessage>
);

export const DisplayInfoMessage = ({
  messageDataList,
  dismissible = false,
}) => (
  <PageLevelMessage
    type="neutral"
    dismissible={dismissible}
    icon={<IconInfo size="md" />}
  >
    {messageDataList?.length === 1
      ? messageDataList[0]
      : (
        <ul>
          {messageDataList.map((msg) => (
            <li key={msg}>{msg}</li>
          ))}
        </ul>
      )}
  </PageLevelMessage>
);

export const DisplayActionResult = ({ apiResult }) => {
  console.log('DisplayActionResult');

  const {
    isError,
    actionId,
    moduleName,
    errMsg,
  } = apiResult;

  if (errMsg) {
    return (
      <>
        <div>
          {!isError ? (
            <DisplaySuccessMessage
              messageDataList={[`Successfully ${actionId} your ${moduleName}`]}
            />
          )
            : (
              <DisplayWarningMessage
                messageDataList={[`Failed to ${actionId} your ${moduleName} ${errMsg ? ` : ${errMsg}` : ''}`]}
              />
            )}
        </div>
      </>
    );
  }

  return (
    <>
      <div>
        {!isError
          ? (
            <DisplaySuccessMessage
              messageDataList={[`Successfully ${actionId} your ${moduleName}`]}
            />
          )
          : (
            <DisplayWarningMessage
              messageDataList={[`Failed to ${actionId} your ${moduleName}`]}
            />
          )}
      </div>
    </>
  );
};

DisplayActionResult.displayName = 'DisplayActionResult';

DisplayActionResult.propTypes = {
  apiResult: PropTypes.shape({
    isError: PropTypes.bool.isRequired,
    actionId: PropTypes.string.isRequired,
    moduleName: PropTypes.string.isRequired,
  }),
};
